import React from 'react';

function Integration() {
  return (
    <div>
      <svg
        width='80'
        height='80'
        viewBox='0 0 80 80'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g filter='url(#filter0_i_115_314)'>
          <rect width='80' height='80' rx='40' fill='currentColor' />
          <path
            d='M45.8965 27.1658C48.1641 24.8887 51.4817 24.8412 53.3176 26.6851C55.1583 28.532 55.1092 31.8717 52.8385 34.1488L49.007 37.9962C48.7912 38.2201 48.6721 38.5199 48.6752 38.8309C48.6784 39.1418 48.8035 39.4391 49.0237 39.6587C49.2439 39.8783 49.5416 40.0026 49.8526 40.0049C50.1635 40.0071 50.463 39.8871 50.6863 39.6708L54.5194 35.8234C57.5413 32.7889 57.9208 27.9454 54.9986 25.0104C52.0731 22.074 47.2391 22.4566 44.214 25.4912L36.551 33.1874C33.5291 36.2219 33.1496 41.0655 36.0719 43.9988C36.181 44.1123 36.3117 44.2029 36.4562 44.2654C36.6008 44.3279 36.7563 44.361 36.9137 44.3627C37.0712 44.3644 37.2274 44.3348 37.3733 44.2755C37.5192 44.2162 37.6518 44.1284 37.7634 44.0174C37.875 43.9063 37.9634 43.7741 38.0233 43.6285C38.0833 43.4829 38.1137 43.3268 38.1127 43.1694C38.1117 43.0119 38.0794 42.8562 38.0176 42.7114C37.9558 42.5665 37.8658 42.4355 37.7528 42.3258C35.9122 40.4788 35.9628 37.1391 38.2319 34.862L45.8965 27.1658Z'
            fill='#FEFEFE'
          />
          <path
            d='M43.9296 35.999C43.7073 35.7761 43.4056 35.6506 43.0908 35.6501C42.776 35.6497 42.4739 35.7743 42.251 35.9966C42.0281 36.2189 41.9026 36.5206 41.9022 36.8354C41.9017 37.1502 42.0264 37.4523 42.2486 37.6752C44.0893 39.5221 44.0403 42.8603 41.7695 45.1389L34.1049 52.8336C31.8357 55.1107 28.5182 55.1581 26.6823 53.3143C24.8416 51.4673 24.8922 48.1276 27.1614 45.8505L30.9945 42.0032C31.1044 41.8928 31.1916 41.7619 31.2509 41.6178C31.3103 41.4738 31.3407 41.3195 31.3404 41.1637C31.3401 41.0079 31.3091 40.8537 31.2492 40.7098C31.1893 40.566 31.1017 40.4354 30.9913 40.3254C30.8809 40.2155 30.75 40.1283 30.606 40.069C30.4619 40.0096 30.3076 39.9792 30.1518 39.9795C29.996 39.9798 29.8418 40.0108 29.6979 40.0707C29.5541 40.1306 29.4235 40.2182 29.3136 40.3286L25.4805 44.1759C22.4586 47.212 22.0791 52.054 25.0013 54.9889C27.9267 57.927 32.7608 57.5427 35.7858 54.5082L43.4504 46.812C46.4723 43.779 46.8518 38.9323 43.9296 35.999Z'
            fill='#FEFEFE'
          />
        </g>
        <defs>
          <filter
            id='filter0_i_115_314'
            x='-4.42632'
            y='-0.737721'
            width='84.4263'
            height='80.7377'
            filterUnits='userSpaceOnUse'
            color-interpolation-filters='sRGB'
          >
            <feFlood flood-opacity='0' result='BackgroundImageFix' />
            <feBlend
              mode='normal'
              in='SourceGraphic'
              in2='BackgroundImageFix'
              result='shape'
            />
            <feColorMatrix
              in='SourceAlpha'
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
              result='hardAlpha'
            />
            <feOffset dx='-4.42632' dy='-0.737721' />
            <feGaussianBlur stdDeviation='2.21316' />
            <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
            <feColorMatrix
              type='matrix'
              values='0 0 0 0 0.564706 0 0 0 0 0.564706 0 0 0 0 0.866667 0 0 0 1 0'
            />
            <feBlend
              mode='normal'
              in2='shape'
              result='effect1_innerShadow_115_314'
            />
          </filter>
        </defs>
      </svg>
    </div>
  );
}

export default Integration;
